export const areUploaderOptionsValid = (options) => options && Object.hasOwn(options, 's3');
